import type { SvgIconName } from '@/types'

// Header 用户菜单与账户相关页侧边二级菜单共用配置
export interface AccountMenuItem {
  key: string
  label: string
  iconName: SvgIconName
  router: string
  match: string[]
  hasDivider?: boolean
  action?: 'logout'
  hasTopDivider?: boolean
}

export const ACCOUNT_MENU_ITEMS: AccountMenuItem[] = [
  {
    label: '存款',
    key: 'deposit',
    iconName: 'svg/user_popover_icon_deposit.svg',
    router: '/deposit',
    match: ['/deposit']
  },
  {
    label: '提款',
    key: 'withdraw',
    iconName: 'svg/user_popover_icon_withdraw.svg',
    router: '/withdraw',
    match: ['/withdraw']
  },
  {
    label: '投注记录',
    key: 'history',
    iconName: 'svg/user_popover_icon_history.svg',
    router: '/bet-history',
    match: ['/bet-history']
  },
  {
    label: '交易记录',
    key: 'transaction',
    iconName: 'svg/user_popover_icon_transaction.svg',
    router: '/trade-history',
    match: ['/trade-history'],
    hasDivider: true
  },
  {
    label: 'brief_security',
    key: 'security',
    iconName: 'svg/user_popover_icon_security.svg',
    router: '/account-security',
    match: ['/account-security']
  },
  {
    label: '收款方式',
    key: 'myBanks',
    iconName: 'svg/user_popover_icon_banks.svg',
    router: '/paymentMethod',
    match: ['/paymentMethod']
  },
  {
    label: 'VIP 中心',
    key: 'vipCenter',
    iconName: 'svg/user_popover_icon_vip_center.svg',
    router: '/vip',
    match: ['/vip']
  },
  {
    label: 'Reward Center',
    key: 'reward',
    iconName: 'svg/user_popover_icon_reward.svg',
    router: '/welfare',
    match: ['/welfare']
  },
  {
    label: 'Referral',
    key: 'referral',
    iconName: 'svg/user_popover_icon_referral.svg',
    router: '/share',
    match: ['/share']
  },
  {
    label: '通知',
    key: 'notification',
    iconName: 'svg/user_popover_icon_notification.svg',
    router: '/notice',
    match: ['/notice']
  },
  {
    hasTopDivider: true,
    label: '登出账户',
    key: 'logout',
    iconName: 'svg/user_popover_icon_logout.svg',
    router: '/',
    match: [],
    action: 'logout'
  }
]
